
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/przyczepy",
      function () {
        return require("private-next-pages/przyczepy/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/przyczepy"])
      });
    }
  